import { Component, OnInit, ViewChild, AfterViewInit, ViewContainerRef } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { environment } from '../../../../../environments/environment';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { TokenStorage } from '../../../../storages/token.storage';
import { OtherKpModel } from '../../models/other-kp-model';
import { OtherKpDetailService } from '../../services/other-kp-detail.service';
import { Nomenclature } from '../../models/nomenclature';
import { ModalOtherKpHistoryChangeComponent } from './modal-history-change/modal-history-change.component';
import { ModalOtherKpMailSenderComponent } from './modal-mail-sender/modal-mail-sender.component';
import { ModalOtherKpSendAdjustmentComponent } from './modal-other-kp-send-adjustment/modal-other-kp-send-adjustment.component';
import { BusOtherKpFilterService } from '../../services/bus-other-kp-filter.service';
import { OtherKpNomenclaturesComponent } from '../other-kp-main/other-kp-main-modal-nomenclature/other-kp-main-modal-nomenclature.component';
import { AgreementStatus } from '../../models/status-enum';

const apiServer = environment.apiServer;
declare var $: any;

@Component({
  selector: 'app-other-kp-modal-detail',
  templateUrl: './other-kp-modal-detail.component.html',
  styleUrls: ['./other-kp-modal-detail.component.scss'],
})

export class OtherKpMainModalDetailComponent implements OnInit, AfterViewInit {
  popupHtmlContent: any = { value: "" }
  errorHtmlContent: any = { value: "" }

  _type: number;
  columnsOtherKp: any[];

  kams: any[] = []
  dbs: any[] = []
  customers: any[] = []
  regions: any[] = []

  otherKp: OtherKpModel = new OtherKpModel();
  dtOptionsOtherKps: DataTables.Settings = {};
  dataSetOtherKp: any;
  http: HttpClient;
  mailPopover = new Array<string>();
  detailDistributionFirst: string;
  detailDistributionSecond: string;
  spinner: NgxSpinnerService;
  token: TokenStorage;
  isChiefRole;
  isContainCd = false;
  isContainFm = false;
  rejected = false;
  isContainSai = false

  hideOutFromDevelopFilter = false

  pageSize = 100
  currentpage = 1
  first

  constructor(private service: OtherKpDetailService,
    private bus: BusOtherKpFilterService,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private _http: HttpClient,
    private _spinner: NgxSpinnerService,
    private _token: TokenStorage) {

    this.toastr.setRootViewContainerRef(vcr)
    this.http = _http
    this.spinner = _spinner
    this.token = _token
  }

  ngAfterViewInit(): void {
    setTimeout(() => { $('[data-toggle="popover"]').popover() }, 1000);
    setTimeout(function () { $('#tableAuction').dataTable(); }, 2000);
  }


  defaultInit() {
    this.updateStateMailIcon()
    this._type = null

    this.isContainCd = false;
    this.isContainFm = false;
    this.rejected = false;

    this.isChiefRole = this.token.isChiefRole()
  }

  ngOnInit() {
    const that = this;
    that.errorHtmlContent.value = ''
    setTimeout(() => { $('[data-toggle="popover"]').popover() }, 1000);
    that.checkTemplates()
    that.columnsOtherKp = [
      { field: 'numberOfRow', header: '№', width: 40, title: 'Порядковый номер строки' },
      { field: 'status', header: 'Статус', width: 140, title: 'Статус согласования' },
      { field: 'name', header: 'Номенклатура', width: 350, title: 'Наименование Солофарм' },
      { field: 'count', header: 'Кол-во', width: 80, title: 'Кол-во в упаковках СолоФарм' },
      { field: 'priceKp', header: 'Цена КП', width: 125, title: 'Цена коммерческого предложения' },
      { field: 'summKp', header: 'Сумма КП', width: 125, title: 'Сумма коммерческого предложения' },
      { field: 'pl', header: 'ПЛ', width: 95, title: 'Стандартная цена прайс-листа СолоФарм' },
      { field: 'sp', header: 'СП', width: 95, title: 'Специальная цена прайс-листа СолоФарм' },
      { field: 'gr', header: 'ГР', width: 95, title: 'Цена госреестра в руб. без НДС' },
      { field: 'marge', header: 'Марж-ть, %', width: 95, title: 'Марж-ть, %' },
    ];

    that.dtOptionsOtherKps = {
      pagingType: 'full_numbers',
      pageLength: 100,
      autoWidth: true,
      dom: 'tip',
      info: false,
    };
    setTimeout(function () { $('#tableAuction').dataTable(); }, 2000);

    that.service.otherKp$.subscribe(otherKp => {
      that.otherKp = otherKp;
      setTimeout(() => { $('[data-toggle="popover"]').popover() }, 1000);
      setTimeout(function () {
        $('#tableAuction').dataTable();

        that.checkTemplates()
        that.updateLocalLists()
        that.updateStateMailIcon();
        that.errorHtmlContent.value = ''
        that.service.triggerReloadNomenclatures()
      }, 2000);
    });

    that.service.triggerSaveObserver$.subscribe(() => {
      that.onSave()
    });

    that.http.post<DataTablesResponse>(`${apiServer}/otherKp/regionsList`, {}, {}).subscribe(regions => {
      that.regions = regions.data
      that.updateLists()
    });
  }

  selectDistibutor(value, row) {
    let distributorId = this.dbs.find(el => el.name == value)?.distributorId
    this.otherKp.distributorId = distributorId
    this.service.currentOtherKp.distributorId = distributorId
  }

  selectKam(value, row) {
    let kamId = this.kams.find(el => el.name == value).kamId
    this.otherKp.kamId = kamId
    this.service.currentOtherKp.kamId = kamId
  }

  selectCustomer(value, row) {
    let customerId = this.customers.find(el => el.name == value).customerId
    this.otherKp.customerId = customerId
    this.service.currentOtherKp.customerId = customerId
    this.checkTemplates()
  }

  selectRegion(value, row) {
    let regionId = this.regions.find(el => el.name == value).regionId
    this.otherKp.regionId = regionId
    this.service.currentOtherKp.regionId = regionId

    this.updateLists()
  }

  updateLocalLists() {
    const that = this;
    if (that.otherKp.regionName != null) {
      let regionId = that.regions.find(el => el.name == that.otherKp.regionName).regionId

      that.http.post<DataTablesResponse>(`${apiServer}/otherKp/kamsList`, { regionId: regionId }, {}).subscribe(kams => {
        that.kams = kams.data
      });
      that.http.post<DataTablesResponse>(`${apiServer}/otherKp/distributorsList`, { regionId: regionId }, {}).subscribe(dbs => {
        that.dbs = dbs.data
      });
      that.http.post<DataTablesResponse>(`${apiServer}/otherKp/customersList`, { regionId: regionId }, {}).subscribe(customers => {
        that.customers = [{ name: "Другое", id: null }].concat(customers.data)
        that.checkTemplates()
      });
    }
  }

  updateLists() {
    const that = this;
    if (that.otherKp.regionName != null) {
      let regionId = that.regions.find(el => el.name == that.otherKp.regionName).regionId

      that.http.post<DataTablesResponse>(`${apiServer}/otherKp/kamsList`, { regionId: regionId }, {}).subscribe(kams => {
        that.kams = kams.data

        that.otherKp.kamId = null
        that.otherKp.kamName = null
        that.service.currentOtherKp.kamId = null
        that.service.currentOtherKp.kamName = null
      });
      that.http.post<DataTablesResponse>(`${apiServer}/otherKp/distributorsList`, { regionId: regionId }, {}).subscribe(dbs => {
        that.dbs = dbs.data

        that.otherKp.distributorId = null
        that.service.currentOtherKp.distributorId = null
        that.otherKp.distributorName = null
        that.service.currentOtherKp.distributorName = null
      });
      that.http.post<DataTablesResponse>(`${apiServer}/otherKp/customersList`, { regionId: regionId }, {}).subscribe(customers => {
        that.customers = [{ name: "Другое", id: null }].concat(customers.data)

        that.otherKp.customerId = null
        that.service.currentOtherKp.customerId = null
        that.otherKp.customerName = 'Другое'
        that.checkTemplates()
      });
    }
  }

  checkTemplates() {
    if (this.otherKp.customerName == "Другое") {
      $('#newCustomerInputs').show()
      $('#nomenclatureLabel').css('margin-top', `45px`);
    } else {
      $('#newCustomerInputs').hide()
      $('#nomenclatureLabel').css('margin-top', `5px`);
    }

    if (this.service.viewKpNumber != "Новый") {
      $('#bottomBtns').show()
      $('#modulesBtns').show()
    } else {
      $('#bottomBtns').hide()
      $('#modulesBtns').hide()
    }
  }

  onExport(): void {
  }

  mailHistory() {
    this.mailPopover[0] = this.mailPopover[1] = this.mailPopover[2] = "Загрузка истории...";
    if (this.service.currentOtherKp.id != null) {
      this.http.get<Array<string>>(apiServer + "/otherKp/history/" + this.service.currentOtherKp.id)
        .subscribe(resp => {
          this.mailPopover = resp;
        });
    }
  }

  @ViewChild(ModalOtherKpHistoryChangeComponent)
  modalHistory: ModalOtherKpHistoryChangeComponent

  historyChange() {
    if (this.modalHistory != undefined) {
      this.modalHistory.loadHistoryChange(this.otherKp.id);
    }
  }


  onSave() {
    let haveErrors = this.haveErrors()
    this.service.isHaveErrors = haveErrors
    if (!haveErrors) {
      this.spinner.show();
      $("button:disabled").attr("title", "");

      let distributorId = this.dbs.find(el => el.name == this.service.currentOtherKp.distributorName)?.distributorId
      if (distributorId) {
        this.otherKp.distributorId = distributorId
        this.service.currentOtherKp.distributorId = distributorId
      }

      let kamId = this.kams.find(el => el.name == this.service.currentOtherKp.kamName)?.kamId
      if (kamId) {
        this.otherKp.kamId = kamId
        this.service.currentOtherKp.kamId = kamId
      }

      let customerId = this.customers.find(el => el.name == this.service.currentOtherKp.customerName)?.customerId
      if (customerId) {
        this.otherKp.customerId = customerId
        this.service.currentOtherKp.customerId = customerId
      }

      if (this.otherKp.customerName == 'Другое') {
        this.otherKp.customerId = null
        this.otherKp.customerName = this.service.newCustomerName
        this.otherKp.inn = this.service.newCustomerInn
        this.service.currentOtherKp.customerId = null
        this.service.currentOtherKp.customerName = this.service.newCustomerName
        this.service.currentOtherKp.inn = this.service.newCustomerInn
      }

      let regionId = this.regions.find(el => el.name == this.service.currentOtherKp.regionName)?.regionId
      if (regionId) {
        this.otherKp.regionId = regionId
        this.service.currentOtherKp.regionId = regionId
      }

      this.service.putOtherKp(this.otherKp, this.spinner)
      if (!this.isContainFm && !this.isContainCd) {
        if (this.rejected) {
          this.SendAdjustmentMail("rejected");
        } else {
          this.SendAdjustmentMail("confirmed");
        }
      }
      this.updateStateMailIcon();
    }
  }

  onSaveAndExit(exit: boolean) {
    let haveErrors = this.haveErrors()
    this.service.isHaveErrors = haveErrors
    if (!haveErrors) {
      this.spinner.show();
      $("button:disabled").attr("title", "");

      let distributorId = this.dbs.find(el => el.name == this.service.currentOtherKp.distributorName)?.distributorId
      if (distributorId) {
        this.otherKp.distributorId = distributorId
        this.service.currentOtherKp.distributorId = distributorId
      }

      let kamId = this.kams.find(el => el.name == this.service.currentOtherKp.kamName)?.kamId
      if (kamId) {
        this.otherKp.kamId = kamId
        this.service.currentOtherKp.kamId = kamId
      }


      let customerId = this.customers.find(el => el.name == this.service.currentOtherKp.customerName)?.customerId
      if (customerId) {
        this.otherKp.customerId = customerId
        this.service.currentOtherKp.customerId = customerId
      }

      if (this.otherKp.customerName == 'Другое') {
        this.otherKp.customerId = null
        this.otherKp.customerName = this.service.newCustomerName
        this.otherKp.inn = this.service.newCustomerInn
        this.service.currentOtherKp.customerId = null
        this.service.currentOtherKp.customerName = this.service.newCustomerName
        this.service.currentOtherKp.inn = this.service.newCustomerInn
      }

      let regionId = this.regions.find(el => el.name == this.service.currentOtherKp.regionName)?.regionId
      if (regionId) {
        this.otherKp.regionId = regionId
        this.service.currentOtherKp.regionId = regionId
      }
      this.service.putOtherKp(this.service.currentOtherKp, this.spinner)
      if (!this.isContainFm && !this.isContainCd) {
        if (this.rejected) {
          this.SendAdjustmentMail("rejected");
        } else {
          this.SendAdjustmentMail("confirmed");
        }
      }
      $('#modalOtherKpDetail').modal('toggle');
    }
  }

  haveErrors(): boolean {
    let haveErrors = false
    this.errorHtmlContent.value = ''
    let regionId = this.regions.find(el => el.name == this.service.currentOtherKp.regionName)?.regionId
    let customerId = this.customers.find(el => el.name == this.service.currentOtherKp.customerName)?.customerId
    let kamId = this.kams.find(el => el.name == this.service.currentOtherKp.kamName)?.kamId
    let distributorId = this.dbs.find(el => el.name == this.service.currentOtherKp.distributorName)?.distributorId

    if (!regionId) {
      this.errorHtmlContent.value += '<br>Требуется выбрать регион'
      haveErrors = true
    }
    if (!customerId) {
      if (this.otherKp.customerName == 'Другое') {
        if (this.service.newCustomerName == "" || this.service.newCustomerInn == "") {
          this.errorHtmlContent.value += '<br>Требуется ввести данные нового заказчика'
          haveErrors = true
        }
      } else {
        this.errorHtmlContent.value += '<br>Требуется выбрать заказчика'
        haveErrors = true
      }
    }
    if (!kamId) {
      this.errorHtmlContent.value += '<br>Требуется выбрать КАМ'
      haveErrors = true
    }
    if (!distributorId) {
      this.errorHtmlContent.value += '<br>Требуется выбрать ДБ'
      haveErrors = true
    }
    if (this.service.currentOtherKp.nomenclatureList.length == 0) {
      this.errorHtmlContent.value += '<br>Требуется выбрать номенклатуру'
      haveErrors = true
    }

    if (this.service.currentOtherKp.nomenclatureList.length > 0) {
      for (let nomenclature of this.service.currentOtherKp.nomenclatureList) {
        if (nomenclature.count == null || nomenclature.priceKp == null || nomenclature.count <= 0 || nomenclature.priceKp <= 0) {
            this.errorHtmlContent.value += '<br>Требуется ввести количество и цену КП для выбранной номенклатуры'
            haveErrors = true
            break
        }
      }
    }

    return haveErrors
  }

  private updateStateMailIcon() {
    this.mailHistory();

    var isNeedAdjustment;
    const st = this.service.currentOtherKp.agreementStatus;
    if (st == "Согласовано" || st == "Не требует согласования") {
      isNeedAdjustment = false;
    } else {
      isNeedAdjustment = true;
    }

    if (this.service.currentOtherKp.distributorName != "" && this.service.currentOtherKp.distributorName != undefined && !isNeedAdjustment && !this.rejected) {
      document.getElementById("buttonMailSender1").classList.remove('text-danger');
      document.getElementById("buttonMailSender1").classList.add('text-success');
      $('#buttonMailSender1').attr("disabled", false);
    } else {
      document.getElementById("buttonMailSender1").classList.remove('text-success');
      document.getElementById("buttonMailSender1").classList.add('text-danger');
      $('#buttonMailSender1').attr("disabled", true);
    }
  }

  hideOutFromDevelop(isHide: boolean) {
    if (this.hideOutFromDevelopFilter != isHide) {
      this.hideOutFromDevelopFilter = isHide
    }
  }

  onSelectedStatus(statusKP) {
    this.service.currentOtherKp.statusKP = statusKP
  }

  onSelectedStatusST(statusST) {
    this.service.currentOtherKp.statusST = statusST
  }

  changeDetail(type: number, rowData: Nomenclature) {
    this.spinner.show();
    let nomenclature = this.service.currentOtherKp.nomenclatureList.find(el => el.goodId == rowData.goodId)
    switch (type) {
      case (1): { //count
        nomenclature.count = Number(rowData.count.toString().replace(',', '.'))
        break;
      }
      case (2): { //priceKp
        nomenclature.priceKp = Number(rowData.priceKp.toString().replace(',', '.'))
        break;
      }
    }
    nomenclature.summKp = (nomenclature.priceKp ?? 0) * (nomenclature.count ?? 0)
    this.service.updateTempData(this.spinner)
    this.updateNeedAdjustmentState()
    this.updateStateMailIcon()
  }

  isShowSaiStatus() {
    if (this.isChiefRole || (this.service.currentOtherKp.statusKP != null &&
      this.service.currentOtherKp.statusKP != undefined &&
      this.service.currentOtherKp.statusKP.toLocaleLowerCase().indexOf("sai") >= 0)) {
      return true;
    } else {
      return false;
    }
  }

  isShowSaiStatusInvert() {
    if (this.isChiefRole) {
      return true;
    } else {
      if (this.service.currentOtherKp.statusKP != null && this.service.currentOtherKp.statusKP != undefined &&
        this.service.currentOtherKp.statusKP.toLocaleLowerCase().indexOf("sai") >= 0) {
        return false;
      }
      return true;
    }
  }

  onSetDistributor() {
    this.otherKp.distributerParticipantName = this.otherKp.distributorName
    this.updateStateMailIcon()
  }

  @ViewChild(ModalOtherKpMailSenderComponent)
  m: ModalOtherKpMailSenderComponent;

  mailToCommercialOffer(type: number) {
    if (this.m != undefined) {
      this.m.mailToCommercialOffer(this.service.currentOtherKp.id, + type, this.popupHtmlContent)
    }
  }

  @ViewChild(ModalOtherKpSendAdjustmentComponent)
  ModalSendAdjustment: ModalOtherKpSendAdjustmentComponent;

  sendAdjustment() {
    this.ModalSendAdjustment.cleannField();
  }

  isOtherKpNeedAdjustment() {
    this.updateNeedAdjustmentState();

    if (this.token.isCD()) {
      // if(this.isContainCd){
      //   return true;
      // }
      return false;
    }

    if (this.service.currentOtherKp.nomenclatureList) {

      if (this.token.isFM() && this.isContainFm && !this.isContainCd) {
        return false;
      }
      if (this.token.isFM() && this.isContainCd) {
        return true;
      }

      if (this.isContainFm || this.isContainCd) {
        return true;
      }

    }
    return false;
  }

  changeTemplate() {
    document.getElementById("buttonMailSender1").classList.remove('text-success');
    document.getElementById("buttonMailSender1").classList.add('text-danger');
    $('#buttonMailSender1').attr("disabled", true);
    $("button:disabled").attr("title", "Необходимо сохранить изменения");
    this.updateNeedAdjustmentState();
  }

  setAdjustment(isAdjustment, rowData) {

    if (!rowData.status) return false;

    if (isAdjustment) {
      rowData.status = "Согласовано"
    } else {
      rowData.status = "Отклонено"
    }

    this.changeTemplate();
    this.isRowNeedAdjustment(rowData);
  }


  // Проверка необходимости согласования
  isRowNeedAdjustment(rowData) {
    if (rowData.status == null || rowData.status == "") return false;

    const st = rowData.status.toLocaleLowerCase();

    if (this.token.isFM() && (st == "согласование с фм")) {
      return true;
    } else if (this.token.isCD() && (st == "согласование с кд" || st == "согласование с фм")) {
      return true;
    }

    return false;
  }

  updateNeedAdjustmentState() {
    this.isContainCd = false;
    this.isContainFm = false;
    this.rejected = false;

    if (this.service.currentOtherKp.nomenclatureList) {
      for (let index = 0; index < this.service.currentOtherKp.nomenclatureList.length; index++) {
        const element = this.service.currentOtherKp.nomenclatureList[index];
        if (element.status == null || element.status == "") return
        const st = element.status.toLowerCase();

        if (st == "согласование с кд") {
          this.isContainCd = true;
        }

        if (st == "согласование с фм") {
          this.isContainFm = true;
        }

        if (st == "отклонено") {
          this.rejected = true;
        }
      }
    }
  }

  SendAdjustmentMail(key) {
    switch (key) {
      case "confirm":
        // Отправка писем на согласование
        if (this.service.currentOtherKp.id != null) {
          this.http.get<Array<string>>(apiServer + "/otherKp/SendMailToConfirm/" + this.service.currentOtherKp.id)
            .subscribe(resp => {
            });
        }
        break;
      case "rejected":
        // Отправка писем отклнонено
        if (this.service.currentOtherKp.id != null) {
          this.http.get<Array<string>>(apiServer + "/otherKp/SendMailToRejected/" + this.service.currentOtherKp.id)
            .subscribe(resp => {
            });
        }
        break;
      case "confirmed":
        // Отправка писем согласовано
        if (this.service.currentOtherKp.id != null) {
          this.http.get<Array<string>>(apiServer + "/otherKp/SendMailToConfirmed/" + this.service.currentOtherKp.id)
            .subscribe(resp => {
            });
        }
        break;

      default:
        break;
    }
  }
}

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-detail/other-kp-modal-detail.component.ts